<script>
import { CLIMA_COLORS } from "../climaColors";
import directionIndicator from "./directionIndicator.vue";
export default {
  template: `
    <div class='is-flex' :class='comparison?"is-justify-end":"is-justify-center"' style='width: 100%; height: 100%; align-items: center;'>
      <span class='clima-total-tag' :style='{ backgroundColor: totalColor, marginRight: comparison ? "15px" : "" }' v-if='group === "CClimad" && !summary.empty'>{{summary.total[group].p.toFixed(1)}}%</span>
      <span :style='comparison?"margin-right: 15px":""' v-else-if='group === "CClimad" && summary.empty'>-</span>
      <div v-if='comparison'>
        <direction-indicator :tooltip='false' :w='25' :h='25' :nombrerangos='nameRanges' :rangos='getRange' :group='group' :summary='summary'></direction-indicator>
      </div>
    </div>
  `,
  data: function() {
    return {
      summary: {},
      group: "",
      comparison: false,
      totalColor: "#a5a5a5",
    };
  },
  props: {
    nameRanges: {
      type: Object,
      required: true,
    },
    getRange: {
      type: Function,
      required: true,
    },
  },
  beforeMount() {
    const params = this.$parent.params;
    this.group = params.colDef.field;
    this.summary = {
      total: params.data,
      empty: params.data.empty || false,
      processComp: {
        total: params.data.comparison,
      },
    };
    this.comparison = Object.keys(this.summary.processComp.total).length;
    if (this.group === "CClimad" && !this.summary.empty) {
      const colors = [
        "#a5a5a5",
        CLIMA_COLORS[1],
        CLIMA_COLORS[2],
        CLIMA_COLORS[3],
        CLIMA_COLORS[4],
        CLIMA_COLORS[5],
        CLIMA_COLORS[6],
      ];
      this.totalColor = colors[this.getRange(params.data[this.group].p)];
    }
  },
  methods: {},
  components: {
    directionIndicator,
  },
};
</script>
<style lang="scss">
.clima-total-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(65, 64, 64, 0.91);
  line-height: 1.4;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/cellComparison.vue